"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateScheduleVisits = validateScheduleVisits;
exports.scheduleVisitsDependencies = scheduleVisitsDependencies;
const domain_1 = require("@home-health-notify/domain");
const dayjs_1 = __importDefault(require("dayjs"));
// Cache to prevent re-fetching on time changes - only fetch when date changes.
// Keyed by chat as well as date: this outlives the form and is never cleared on
// an organization switch, and the request is org-scoped, so a date-only key
// served one organization's visits inside another. A chat belongs to exactly one
// organization, so keying by it scopes the cache without threading an org id in.
let scheduledVisitsCache = { chatId: null, date: null, visits: [] };
function validateScheduleVisits(field, formData, chat) {
    return __awaiter(this, void 0, void 0, function* () {
        const futureAppointment = formData[field];
        let scheduledVisits = [];
        if (futureAppointment === null || futureAppointment === void 0 ? void 0 : futureAppointment.visitDate) {
            const startOfDate = futureAppointment.visitDate;
            const endOfDate = (0, dayjs_1.default)(futureAppointment.visitDate).endOf("day").valueOf();
            // Only fetch if the chat or date has changed
            const chatId = chat.getChatId();
            if (scheduledVisitsCache.chatId !== chatId ||
                scheduledVisitsCache.date !== futureAppointment.visitDate) {
                // Unscoped by chat: the backend rejects a conflicting slot anywhere in the
                // user's day, so a chat-scoped list would hide cross-group conflicts and
                // never surface the "Allow Conflict" option.
                yield chat.getScheduleVisits({
                    type: domain_1.CALENDAR_EVENT_TYPE.PROJECTED,
                    startDate: startOfDate,
                    endDate: endOfDate,
                }, true);
                // Reminders are notification schedules, not visits: the unscoped query
                // returns them alongside revisits, and the backend never treats them as a
                // conflict.
                scheduledVisits = chat.scheduledVisits.filter(visit => visit.type !== domain_1.SCHEDULE_TYPE.REMINDER);
                scheduledVisitsCache = {
                    chatId,
                    date: futureAppointment.visitDate,
                    visits: scheduledVisits,
                };
            }
            else {
                scheduledVisits = scheduledVisitsCache.visits;
            }
        }
        else {
            // Clear cache when date is removed
            scheduledVisitsCache = { chatId: null, date: null, visits: [] };
        }
        if ((futureAppointment === null || futureAppointment === void 0 ? void 0 : futureAppointment.visitDate) &&
            (futureAppointment === null || futureAppointment === void 0 ? void 0 : futureAppointment.visitStartTime) &&
            (futureAppointment === null || futureAppointment === void 0 ? void 0 : futureAppointment.visitEndTime)) {
            const conflictingVisitIds = findConflictingVisits(scheduledVisits, futureAppointment).map(visit => visit.id);
            const isConflicting = conflictingVisitIds.length > 0;
            return {
                formData: Object.assign(Object.assign({}, formData), { [field]: Object.assign(Object.assign({}, futureAppointment), { isError: isConflicting, isConflictAllowed: isConflicting
                            ? futureAppointment.isConflictAllowed
                            : false }) }),
                scheduledVisits,
                visitDate: futureAppointment.visitDate,
                conflictingVisitIds,
            };
        }
        return {
            scheduledVisits,
            visitDate: futureAppointment === null || futureAppointment === void 0 ? void 0 : futureAppointment.visitDate,
            conflictingVisitIds: [],
        };
    });
}
function findConflictingVisits(scheduledVisits = [], data) {
    return scheduledVisits.filter(item => {
        // Check if the date matches (assuming both dates are in the same time zone)
        const isSameDate = item.schedulerDate === data.visitDate;
        // Check if there is a time overlap
        const isTimeConflict = item.schedulerTime && item.schedulerEndTime
            ? item.schedulerEndTime > data.visitStartTime &&
                item.schedulerTime < data.visitEndTime
            : false;
        return isSameDate && isTimeConflict;
    });
}
function scheduleVisitsDependencies(field, formData) {
    const futureAppointment = formData[field];
    return [
        futureAppointment === null || futureAppointment === void 0 ? void 0 : futureAppointment.visitDate,
        futureAppointment === null || futureAppointment === void 0 ? void 0 : futureAppointment.visitStartTime,
        futureAppointment === null || futureAppointment === void 0 ? void 0 : futureAppointment.visitEndTime,
    ];
}
